package app.nestbridge.app.context.identity

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class DefaultUserContextProvider : UserContextProvider {

    private val _context = MutableStateFlow<UserContext?>(null)
    override val context: StateFlow<UserContext?> = _context.asStateFlow()

    override fun set(context: UserContext?) {
        _context.value = context
    }

    override fun clear() {
        _context.value = null
    }
}
